import store from '@/store/index'
import router from '@/router'

// Check 2 cases:
// + When user switch to another merchant account => we should redirect back to dashboard page
// + When user is new => we should redirect to dashboard too
export default async function farahRouteGuard(to, from, next) {
  // To force advertiser already fetched before access any ads page
  await store.dispatch('farah/checkUserType')
  const merchantProfile = store.getters['profile/profile']

  const isEnabledFarahPromotionReview = ['SA', 'AE'].includes(
    merchantProfile?.country
  )

  if (!isEnabledFarahPromotionReview) {
    router.replace('/')
    return
  }

  // If redirect back to ads dashboard then we can ignore the check
  // since ads dashboard is also the onboarding page for new adtech merchant
  if (to.path === '/deals/dashboard') {
    next()
    return
  }

  const selectedMerchant = localStorage.getItem('selectedMerchant')
  const adTechMerchant = localStorage.getItem('adTechMerchant')
  let proceedToNext = false

  // If the merchant is new (adTechMerchant null) or user select different merchant (adTechMerchant !== selectedMerchant)
  // then redirect to ads dashboard
  // If NOT then continue routing
  if (!adTechMerchant || adTechMerchant !== selectedMerchant) {
    // If advertiser didn't initialzed, should return undefined
    const isMerchantInitialized = await store.dispatch('ads/fetchAdvertiser')

    if (isMerchantInitialized) {
      localStorage.setItem('adTechMerchant', selectedMerchant)
      proceedToNext = true
    }
  } else {
    proceedToNext = true
  }

  next(proceedToNext ? undefined : '/deals/dashboard')
}
